import React, { FC } from 'react';
import { Chip, makeStyles } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

export const statusChipStyles = makeStyles(() => ({
	smallChip: {
		position: 'relative',
		width: 120,
		'& .MuiChip-avatarColorPrimary': {
			backgroundColor: 'unset'
		},
		'& .MuiChip-avatarColorSecondary': {
			backgroundColor: 'unset'
		},
		'& .MuiChip-avatar': {
			position: 'absolute',
			left: 0
		},
		'& .MuiChip-label': {
			position: 'absolute',
			left: 23,
			maxWidth: 97,
			overflow: 'hidden'
		}
	},
	mediumChip: {
		position: 'relative',
		width: 150,
		'& .MuiChip-avatarColorPrimary': {
			backgroundColor: 'unset'
		},
		'& .MuiChip-avatarColorSecondary': {
			backgroundColor: 'unset'
		},
		'& .MuiChip-avatar': {
			position: 'absolute',
			left: 0
		},
		'& .MuiChip-label': {
			position: 'absolute',
			left: 23,
			maxWidth: 127,
			overflow: 'hidden'
		}
	},
	bigChip: {
		position: 'relative',
		width: 180,
		'& .MuiChip-avatarColorPrimary': {
			backgroundColor: 'unset'
		},
		'& .MuiChip-avatarColorSecondary': {
			backgroundColor: 'unset'
		},
		'& .MuiChip-avatar': {
			position: 'absolute',
			left: 0
		},
		'& .MuiChip-label': {
			position: 'absolute',
			left: 23,
			maxWidth: 157,
			overflow: 'hidden'
		}
	},
	availableChip: {
		'&.MuiChip-colorPrimary': {
			backgroundColor: '#16A34A'
		}
	},
	notAvailableChip: {
		backgroundColor: '#F59E0B'
	}
}));

const StatusChip: FC<StatusChipProps> = (props) => {
	const { className, status, name } = props;
	const classes = statusChipStyles();

	let statusStr = 'Unknown';
	let color: 'default' | 'primary' | 'secondary' = 'default';
	let avatar = <HelpOutlineIcon />;
	let statusClassName = '';

	if (status === 'COMPLETED') {
		statusStr = 'Completed';
		color = 'primary';
		avatar = <CheckCircleOutlineIcon color='secondary' />;
	} else if (status && ['IN_PROGRESS', 'LIVE'].includes(status)) {
		statusStr = 'In progress';
		color = 'secondary';
		avatar = <PlayCircleOutlineIcon color='secondary' />;
	} else if (status && ['SCHEDULED_WITH_MAF', 'SCHEDULED'].includes(status)) {
		statusStr = 'Scheduled';
		avatar = <AccessTimeIcon />;
	} else if (status && ['POSTPONED', 'NOT_SCHEDULED_WITH_MAF'].includes(status)) {
		statusStr = 'Postponed';
		avatar = <HighlightOffIcon />;
	} else if (status === 'AVAILABLE') {
		statusStr = 'Available';
		color = 'primary';
		avatar = <CheckCircleOutlineIcon />;
		statusClassName = classes.availableChip;
	} else if (status === 'NOT_AVAILABLE') {
		statusStr = 'Not available';
		avatar = <HighlightOffIcon />;
		statusClassName = classes.notAvailableChip;
	}

	const chipClassName = `${className || ''} ${statusClassName}`.trim();

	return <Chip label={name || statusStr} color={color} className={chipClassName} avatar={avatar} />;
};

type StatusChipProps = {
	className: string;
	status?: string | null;
	name?: string;
};

export default StatusChip;
